export const FREE_SHIPPING_DATA_QUERY_KEY = 'free-shipping-modal-data';
